import AxiosURLSearchParams from "../../../helpers/AxiosURLSearchParams.mjs";
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
export {
  URLSearchParams$1 as default
};
